export default __webpack_public_path__ + "static/media/logo.d06552f4.png";